// LoaderOverlay.jsx
import React from "react";
import "./LoaderOverlay.css";

const LoaderOverlay = () => {
    return (
        <div className="loader-overlay">
            <div className="loader-spinner"></div>
            {/* Tu peux ajouter un texte de type "Génération en cours..." si tu veux */}
            <p className="loader-text">Génération de l'image en cours...</p>
        </div>
    );
};

export default LoaderOverlay;
